import { render } from "./ForgotPswdPage.vue?vue&type=template&id=6f0ce7e8&scoped=true"
import script from "./ForgotPswdPage.vue?vue&type=script&lang=js"
export * from "./ForgotPswdPage.vue?vue&type=script&lang=js"

import "./ForgotPswdPage.vue?vue&type=style&index=0&id=6f0ce7e8&scoped=true&lang=css"

import exportComponent from "D:\\Development\\javascript\\accounts-butago-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0ce7e8"]])

export default __exports__